export default function registerAiTemplateGenerator(Alpine) {
  const POLL_INTERVAL_MS = 1500;
  const POLL_TIMEOUT_MS = 5 * 60 * 1000;

  Alpine.data("aiTemplateGenerator", () => ({
    prompt: "",
    loading: false,
    error: null,

    async generate() {
      this.loading = true;
      this.error = null;

      const form = document.querySelector("form[id^='new_document_template'], form[id^='edit_document_template']");
      const nameInput = form?.querySelector("[name='document_template[name]']");
      const templateType = form?.querySelector("[name='document_template[template_type]']")?.value || "proposal";
      const locale = form?.querySelector("[name='document_template[locale]']")?.value || "nb";
      const documentTemplateId =
        form?.querySelector("[name='document_template_id_hidden']")?.value ||
        document.body.dataset.documentTemplateId ||
        null;
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

      try {
        const response = await fetch("/document_templates/generate_ai", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
            Accept: "application/json"
          },
          body: JSON.stringify({
            prompt: this.prompt,
            document_template_id: documentTemplateId,
            document_template: {
              name: nameInput?.value || "",
              template_type: templateType,
              locale
            }
          })
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          this.error = data.error || `Request failed (${response.status})`;
          this.loading = false;
          return;
        }

        if (data.redirect_url) {
          window.location.assign(data.redirect_url);
          return;
        }

        this.error = "Missing redirect URL in response";
        this.loading = false;
      } catch (e) {
        this.error = e.message || "An error occurred";
        this.loading = false;
      }
    }
  }));

  Alpine.data("aiTemplateGenerationStatus", () => ({
    generationId: null,
    status: "pending",
    error: null,

    init() {
      this.generationId = this.$el.dataset.generationId;
      if (!this.generationId) return;
      this.poll();
    },

    async poll() {
      const start = Date.now();

      while (Date.now() - start < POLL_TIMEOUT_MS) {
        await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));

        try {
          const response = await fetch(`/document_templates/generations/${this.generationId}`, {
            headers: { Accept: "application/json" }
          });

          if (!response.ok) {
            this.status = "failed";
            this.error = `Status check failed (${response.status})`;
            return;
          }

          const data = await response.json();
          this.status = data.status;

          if (data.status === "succeeded") {
            const url = new URL(window.location.href);
            url.searchParams.delete("generation_id");
            window.location.replace(url.toString());
            return;
          }

          if (data.status === "failed") {
            this.error = data.error || "Generation failed";
            return;
          }
        } catch (e) {
          this.status = "failed";
          this.error = e.message || "Status check failed";
          return;
        }
      }

      this.status = "failed";
      this.error = "Generation timed out";
    }
  }));
}
